export default __webpack_public_path__ + "static/media/nft3.fbc87f74.jpg";